"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "23", height: "21", viewBox: "0 0 23 21", className: "Icon nav-export", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#777", fillRule: "nonzero" },
            _react2.default.createElement("path", { d: "M14.325 1.675H1.675v17.65h12.65V1.675zm.675 19H1A.675.675 0 0 1 .325 20V1C.325.627.627.325 1 .325h14c.373 0 .675.302.675.675v19a.675.675 0 0 1-.675.675z" }),
            _react2.default.createElement("path", { d: "M20.864 11.12l-1.675 1.629a.625.625 0 0 0 .872.896L22.779 11a.625.625 0 0 0 .007-.89l-2.718-2.727a.625.625 0 0 0-.886.882l1.599 1.604H9.005a.625.625 0 0 0 0 1.25h11.859z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/nav-export.js
// module id = 1817
// module chunks = 0